export const patchVersion = {
  patchNotesNumber: 16,
  version: '1.6.3',
};

export const maintenance = {
  maintenanceEnabled: false,
  messageDate: 'March 4th, 2026',
  messageContent:
    'Welcome to Tech Insights! Insights will be unavailable for maintenance from 2:15 PM PDT to 2:45 PM PDT. We are working on some exciting updates to enhance your experience. Insights will be temporarily unavailable during this period. We appreciate your patience and understanding as we work to bring you new features and improvements. Stay tuned for more updates!',
};
